import React from 'react';
import { Link } from 'react-router-dom';
import Event from '../../pages/events/event';

import './next-gig.scss';
import { getNextGig } from './next-gig.fn';

var nextGig = getNextGig();

function NextGig() {
    return (
        <div className='outer-container'>
            <h3 className='title'>Next Gig</h3>
            {nextGig !== undefined && nextGig.id !== undefined && nextGig.description !== undefined ?
                <div className='container'>
                    <div className='content-container'>
                        <Event event={nextGig} />
                    </div>
                    <div className='all-events'>See all events <Link reloadDocument to="events">here</Link></div>
                </div>
                :
                <div className='container no-events'>
                    <div>
                        Check back for upcoming gigs
                    </div>
                    <div className='all-events'>See all events <Link reloadDocument to="events">here</Link></div>
                </div>
            }
        </div>
    )
}

export default NextGig;